module.exports = __webpack_public_path__ + "img/万科@2x.6e84c930.png";